/* One-time migration of positively identified EasyGift lines in this theme.
   Never adds gifts; never changes an unmarked/paid bundle or fountain line. */
(() => {
  const config = document.getElementById('VitaCatLegacyGift');
  if (!config) return;
  const candidates = JSON.parse(config.textContent);
  if (!candidates.length) {
    window.VitaCatLegacyGiftReady = Promise.resolve();
    return;
  }

  async function reconcile() {
    const drawer = document.querySelector('cart-drawer');
    const page = document.querySelector('cart-items');
    // Shrine upgrades cart elements asynchronously after DOMContentLoaded.
    // Do not read their native methods until those definitions are ready.
    await Promise.all([
      drawer ? customElements.whenDefined('cart-drawer') : Promise.resolve(),
      page ? customElements.whenDefined('cart-items') : Promise.resolve()
    ]);
    const read = await fetch(`${Shopify.routes.root}cart.js`, { cache: 'no-store' });
    if (!read.ok) throw new Error('Could not read legacy gift cart');
    const cart = await read.json();
    const updates = {};
    cart.items.forEach(item => {
      if (item.variant_id === 46310761496747 &&
          item.product_id === 8702905974955 &&
          item.properties?._Gifted === 'Gratis present' &&
          item.final_line_price === 0 && candidates.includes(item.key)) {
        updates[item.key] = 0;
      }
    });
    if (!Object.keys(updates).length) return;

    const pageSections = page?.getSectionsToRender() || [];
    const drawerSections = drawer?.getSectionsToRender() || [];
    const sections = [...new Set([
      ...pageSections.map(s => s.section),
      ...drawerSections.map(s => s.id)
    ])];
    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates, sections, sections_url: location.pathname })
    });
    if (!response.ok) throw new Error('Could not reconcile legacy gift');
    const result = await response.json();
    if (result.errors) throw new Error('Legacy gift reconciliation rejected');
    // HTML below is Shopify's own escaped Liquid section response, matching
    // the existing native cart renderer (not user-supplied arbitrary HTML).
    // Use the existing theme's section rendering; no reload or index changes.
    if (drawer) {
      drawer.classList.toggle('is-empty', result.item_count === 0);
      drawer.renderContents(result, true);
    }
    pageSections.forEach(section => {
      const target = document.getElementById(section.id);
      const html = result.sections?.[section.section];
      if (!target || !html) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.querySelector(section.selector);
      if (source) (target.querySelector(section.selector) || target).innerHTML = source.innerHTML;
    });
    page?.classList.toggle('is-empty', result.item_count === 0);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', result.item_count === 0);
    document.dispatchEvent(new CustomEvent('vitacat:legacy-gift-reconciled', {
      detail: { removed: Object.keys(updates).length }
    }));
  }
  const start = () => { window.VitaCatLegacyGiftReady = reconcile().catch(error => {
    // Fail safe: retain the genuine cart line, never hide a failed removal.
    console.warn('[VitaCat visual gift]', error.message);
  }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
